import {
  TLD_VALUES as ALL_AVAILABLE_TLDS,
  DEFAULT_TLDS as BASE_DEFAULT_TLDS,
  type Tld,
} from '~/config/tld-lists';

// Re-export the TLD values and types
export const TLD_VALUES = ALL_AVAILABLE_TLDS;
export const DEFAULT_TLDS = BASE_DEFAULT_TLDS;
export type { Tld };

// Helper function to get all TLDs or filter explicit ones
export const getAllTlds = (explicitTlds?: Tld[] | string[]): Tld[] => {
  if (!explicitTlds || explicitTlds.length === 0) {
    return [...TLD_VALUES];
  }

  // Filter out undefined values and normalize TLDs
  const validTlds = explicitTlds
    .filter((tld): tld is string => typeof tld === 'string')
    .map((tld) => (tld.startsWith('.') ? tld : `.${tld}`))
    .filter((tld): tld is Tld => TLD_VALUES.includes(tld as Tld));

  // If no valid TLDs found, return default TLDs
  return validTlds.length > 0 ? validTlds : [...DEFAULT_TLDS];
};
